import { defineComponent as _defineComponent } from 'vue'
import LButton from '@/components/core/Button.vue'
import { useContext } from '@/composables/context'
import { useTransportationStore } from '@/stores/transportation'
import { DateRange } from '@/types/transportation'
import { Location } from '@/types/trip'
import { locationToAutocompleteResult } from '@/utils/location'
import { getDefaultEmojiForTransportationType } from '@/utils/transportation'

export interface TravelPlanAddButtonProps {
  alwaysVisible?: boolean
  placement: 'top' | 'bottom'
  waypointId: string
  period?: DateRange
  origin?: Location
  destination?: Location
  index?: number
  isArrivalTransportation?: boolean
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TravelPlanAddButton',
  props: {
    alwaysVisible: { type: Boolean },
    placement: null,
    waypointId: null,
    period: null,
    origin: null,
    destination: null,
    index: null,
    isArrivalTransportation: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  alwaysVisible?: boolean
  placement: 'top' | 'bottom'
  waypointId: string
  period?: DateRange
  origin?: Location
  destination?: Location
  index?: number
  isArrivalTransportation?: boolean
};



const { i18n } = useContext()
const transportationStore = useTransportationStore()

function openTransportationSlideOver() {
  transportationStore.selectTransportation({
    transportation: {
      type: 'driving',
      emoji: getDefaultEmojiForTransportationType('driving'),
      label: i18n.t('transportation.driving.label').toString(),
      documents: [],
      rentals: [],
      isArrivalTransportation: props.isArrivalTransportation,
      period: props.period,
      origin: props.origin
        ? locationToAutocompleteResult(props.origin)
        : undefined,
      destination: props.destination
        ? locationToAutocompleteResult(props.destination)
        : undefined,
    },
    waypointId: props.waypointId,
    index: props.index,
  })
}

return { __sfc: true,props, i18n, transportationStore, openTransportationSlideOver, LButton }
}

})